import { Component, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CustomerCampaignService } from '../../../services/customer-campaign.service';

@Component({
  selector: 'app-components-shared-minimum-customer-campaign',
  templateUrl: './minimum-customer-campaign.component.html',
  styleUrls: ['./minimum-customer-campaign.component.scss']
})
export class MinimumCustomerCampaignComponent implements OnInit {
  @Input() customer: Boo.Objects.Customer;

  isLoading = false;
  websiteUrls: Boo.Objects.WebsiteUrl[];

  websiteUrlStatuses_New = Boo.Objects.Enums.WebsiteUrlStatuses.New;
  websiteUrlStatuses_Supporting = Boo.Objects.Enums.WebsiteUrlStatuses.Supporting;
  websiteUrlStatuses_Target = Boo.Objects.Enums.WebsiteUrlStatuses.Target;
  websiteUrlStatuses_Archived = Boo.Objects.Enums.WebsiteUrlStatuses.Archived;

  constructor(private customerCampaignService: CustomerCampaignService) {}

  ngOnInit(): void {
    this.customerCampaignService.getWebsiteUrls(this.customer.CustomerId, true, [Boo.Objects.Enums.WebsiteUrlStatuses.Target])
      .pipe(finalize(() => this.isLoading = false))
        .subscribe({
          next: websiteUrls => {
            this.websiteUrls = websiteUrls.map(websiteUrl => {
              websiteUrl.Keywords = websiteUrl.Keywords.sort((a, b) => a.KeywordPhrase.localeCompare(b.KeywordPhrase));
              return websiteUrl;
            }).sort((a, b) => a.Url.localeCompare(b.Url));
          },
          error: (err) => toastr.error(err)
        });
  }

  copyUrl(url: string): void {
    navigator.clipboard.writeText(url)
      .then(() => {
        toastr.success('Copied to clipboard');
      })
      .catch((err) => {
        toastr.error('Failed to copy to clipboard');
        console.error(err);
      });
  }
}